export default {
  'footer.faq': {
    id: 'footer.faq',
    defaultMessage: 'FAQ',
  },
  'footer.contact': {
    id: 'footer.contact',
    defaultMessage: 'Contact',
  },
  'footer.cookies': {
    id: 'footer.cookies',
    defaultMessage: 'Cookies',
  },
  'aboutView.pro.title': {
    id: 'aboutView.pro.title',
    defaultMessage: 'About',
  },
  'slide.title.works-with': {
    id: 'slide.title.works-with',
    defaultMessage: 'Works With',
  },
  'footer.privacyPolicy': {
    id: 'footer.privacyPolicy',
    defaultMessage: 'Privacy policy',
  },
  'footer.termsOfService': {
    id: 'footer.termsOfService',
    defaultMessage: 'Terms of service',
  },
};
